import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  useTranslation,
  LangType,
  TranslationKey,
} from "./hooks/useTranslation";

const MAIN_PATH = "/";
const PROJECTS_PATH = "/projects";
const CONTACTS_PATH = "/contacts";
const EXHIBITION_PATH = "/exhibition";
const EXPERIMENTS_PATH = "/experiments";

interface NavBarProps {
  lang: LangType;
  setLang: (lang: LangType) => void;
}

const navLinks = [
  { path: MAIN_PATH, label: "about" },
  { path: PROJECTS_PATH, label: "projects" },
  { path: EXHIBITION_PATH, label: "exhibition" },
  { path: EXPERIMENTS_PATH, label: "experiments" },
  { path: CONTACTS_PATH, label: "contacts" },
];

export const NavBar: React.FC<NavBarProps> = ({ lang, setLang }) => {
  const location = useLocation();
  const t = useTranslation(lang);
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = window.innerWidth < 850;

  const renderLinks = (onClick?: () => void, tabIndex?: number) =>
    navLinks.map(({ path, label }) => (
      <Link
        key={path}
        className={
          location.pathname === path ? "route-link active" : "route-link"
        }
        to={path}
        onClick={onClick}
        tabIndex={tabIndex}
      >
        {t(label as TranslationKey)}
      </Link>
    ));

  return (
    <nav className="menu-container">
      <div className="author">{t("author")}</div>
      <div className="menu-list">
        {isMobile ? (
          <>
            <button
              className="menu-toggle"
              aria-label="Toggle menu"
              onClick={() => setIsOpen((prev) => !prev)}
              style={{
                background: "transparent",
                border: "none",
                color: "inherit",
                cursor: "pointer",
                fontSize: "inherit",
                padding: 0,
              }}
            >
              <i className="bi bi-list" />
            </button>
            <div
              className="menu-burger"
              style={{ display: isOpen ? "block" : "none" }}
              aria-hidden={!isOpen}
            >
              {renderLinks(() => setIsOpen(false), isOpen ? 0 : -1)}
            </div>
          </>
        ) : (
          <div className="menu">{renderLinks()}</div>
        )}
        <button
          className="lang"
          aria-label="Switch language"
          onClick={() =>
            setLang(lang === LangType.UA ? LangType.EN : LangType.UA)
          }
          style={{
            background: "transparent",
            border: "none",
            color: "inherit",
            cursor: "pointer",
            fontSize: "inherit",
            padding: 0,
          }}
        >
          {lang}
        </button>
        <span aria-label={t("heartFilled") ? "Favorite" : "Not favorite"}>
          {t("heartFilled") ? (
            <i className="bi bi-heart-fill"></i>
          ) : (
            <i className="bi bi-heart"></i>
          )}
        </span>
      </div>
    </nav>
  );
};
